import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import type { HanziScript } from "@-/dev.improve.haniverse.lib.actor.types";
import { useActorUser } from "@-/dev.improve.haniverse.lib.user";
import { NavContext } from "@-/dev.improve.haniverse.routes.nav._context";
import {
  availableHanziScript,
  useTraditionalCharactersEnabled,
} from "@-/dev.improve.haniverse.lib.posthog";

/**
 * The script the app should render right now: the session-only header override when one is set,
 * otherwise the user's persisted setting. Mirrors {@link useEffectiveIsToneColorsEnabled} — `null`
 * is the "no override" sentinel, so `??` (not a truthiness check) is what falls through.
 */
export function useEffectiveHanziScript(): HanziScript {
  const { hanziScript } = useActorUser();
  const [hanziScriptOverride] = useContextSelectors(NavContext, (c) => c.hanziScriptOverride);
  const traditionalCharactersEnabled = useTraditionalCharactersEnabled();
  return availableHanziScript(hanziScriptOverride ?? hanziScript, traditionalCharactersEnabled);
}
